<template>
  <div class="uploader">
    <el-upload v-loading="loading" class="mr20 blue"  v-if="fileFuther.fileUrl && delBtn"
      :action="FileUploadURL" :show-file-list="false"  :accept="accept"
      :on-success="handleSuccess"  :before-upload="handlebeforeUpload">
        <el-button small slot="trigger">重新上传</el-button>
    </el-upload>
    <div :class="{'mr20': true,'blue': true,'new-style': showBtnFlag=='2'}" v-if="fileFuther.fileUrl">
      <div class="fileurl-img" v-if="showBtnFlag=='2'">
        <img v-if="fileUrlLast == 'docx' || fileUrlLast == 'doc' || fileUrlLast == 'xls'|| fileUrlLast == 'xlsx'" src="@/assets/icon/download-img.png" >
        <img v-else src="@/assets/icon/look-img.png">
      </div>
      <el-link v-if="fileUrlLast == 'docx' || fileUrlLast == 'doc' || fileUrlLast == 'xls'|| fileUrlLast == 'xlsx'" type="primary" :underline="false"  target="_blank" :href="fileFuther.fileUrl">下载文件</el-link>
      <el-link v-else type="primary" :underline="false" @click='previewLook(fileFuther.fileUrl)'>预览</el-link>
    </div>
    <div class="mr20 blue" v-if="fileFuther.fileUrl && delBtn">
      <el-link type="primary" @click="del()" :underline="false" >删除</el-link>
    </div>
    <el-dialog title="预览" :visible.sync="centerDialogVisible" width="70%" center :append-to-body='true'>
      <div style="display:flex; align-items: center; justify-content: center;">
        <el-image :src="imgurl"  style="width:80%;"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OtherOneUpload',
  props: {
    showBtnFlag: {
      default: '1', // 1是以前展示;2是新按钮样式
      type: String
    },
    fileFuther:Object,     
    index:'',
    delBtn:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      FileUploadURL: this.$common.FileUploadURL,
      loading: false,
      centerDialogVisible: false,
      fileTypeInChild:'', // 文件的格式 pdf 或 img
      imgurl: '',
      accept:'image/*,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/*,application/msword,application/vnd.ms-excel'
    }
  },
  computed: {
    fileUrlLast(){
       return this.fileFuther.fileUrl.substr(this.fileFuther.fileUrl.lastIndexOf(".") * 1 + 1);      
    }
  },
  methods: {
    del() {
      this.$emit('delOtherImg',this.index)
    },
    handleSuccess(res, file) {
      this.loading = false
      if(res.code == 1000){
        this.$message.success('上传成功')
        this.fileFuther.fileUrl = res.data,
        this.fileFuther.fileName = file.name,
        this.$forceUpdate();
      } else {
        return this.$message.error('上传失败')
      }
    },
    handlebeforeUpload(file) {
      console.log(file,file.type,'===file.type')
      this.loading = true
      // 这里做可以做文件校验操作
      let isImg = false
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === "application/pdf" || file.type === 'application/msword' || file.type === 'application/vnd.ms-excel'|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type ==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        isImg = true;
      }
      if (!isImg) {
        this.loading = false
        this.$message.error('上传文件只能是JPG、PNG、PDF、WORD、EXCEL格式 !')
      }
      let isLt5M = file.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.loading = false
        this.$message.error('上传图片大小不能超过 50MB!')
      }
      return isImg && isLt5M
    },
    previewLook(url){
      this.imgurl = url
      //获取最后一个.的位置
      let index = this.imgurl.lastIndexOf(".");
      //获取后缀
      this.fileTypeInChild = this.imgurl.substr(index+1);
      if(this.fileTypeInChild == 'pdf'){
        window.open(this.imgurl, "_blank");
      }else{
        this.centerDialogVisible=true
      }
      this.$forceUpdate();
    },
  }
}
</script>
<style scoped lang="scss">
.uploader {
  width: auto;
  height: auto;
  .blue{
    cursor: pointer;
    color: #007BFF;
    border: 1px solid #007BFF;
    font-size: 10px;
    border-radius: 2px;
    height:30px;
    line-height: 30px;
    width: 70px;
    display: inline-block;
    text-align:center;
    line-height: 1;
    .el-upload{
      .el-button{
        height:30px;
        line-height: 30px;
        width: 70px;
        display: inline-block;
        border: none;
        padding: 0;
        margin: 0;
        color: #007BFF;
      }
    }
    .el-link{
       color: #007BFF;
      height:30px;
      line-height: 30px;
    }
    &:hover {
      background:  none;
    }
  }
  .new-style {
    width: auto;
    background: #FFFFFF;
    border: 1px solid #EBECEF;
    border-radius: 2px;
    padding: 7px 9px;
    line-height: 10px;
    display: flex;
    &>.el-link {
      font-family: PingFangSC-Regular;
      font-size: 10px;
      color: #394259;
      letter-spacing: 0;
      text-align: center;
      line-height: 10px;
      height: auto;
    }
    .fileurl-img {
      &>img{
        margin-right:7px;
        width: 13px;
        height: 13px;
      }
    }
  }
}
</style>